export const BranchesEndpoints = {
    list: () => '/branches/list',
    details: () => '/branches/details',
    create: () => '/branches',
    update: (id: string) => `/branches/${id}`,
    delete: (id: string) => `/branches/${id}`,
    archive: (id: string) => `/branches/${id}/archive`,
    unarchive: (id: string) => `/branches/${id}/unarchive`,
    apiToken: (id: string) => `/branches/${id}/api-token`,
    revealApiToken: (id: string) => `/branches/${id}/api-token/reveal`,
};
